import { styled } from "../../../../styled-system/jsx";

const Card = styled("div", {
  base: {
    position: "relative",
    borderRadius: "card",
    minWidth: "0",
    padding: "medium",
    backgroundColor: "white",
    boxShadow: "card",
  },
  variants: {
    variant: {
      flat: {
        border: "1px solid",
        borderColor: "border.default",
        boxShadow: "none",
      },
    },
    isSelected: {
      true: {
        boxShadow: "inset 0 2px 8px 0 rgba(0,0,0,0.10)",
      },
    },
  },
});

export default Card;
